export default __webpack_public_path__ + "static/media/TUN.7a98e09a.svg";